import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class HideWhenZero extends BaseOption {
  static userInterfaceComponent = {
    label: "Hide When Zero",
    optionDataType: BaseOption.DataType.Boolean,
    component: inspectorTools.RADIO_BAR,
    descriptionMessage: "Show nothing while nobody has joined, instead of a zero count.",
    props: {
      options: [
        {
          label: "Yes",
          value: true,
          tooltip: "",
        },
        {
          label: "No",
          value: false,
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = false;

  static convertConfigValueToCompiledValue(configValue) {
    return [true, "true", "yes"].includes(configValue);
  }
}
